import {
    GET_REJECT_SET_REASONS,
    GET_REJECT_SET_REASONS_SUCCESS,
    GET_REJECT_SET_REASONS_FAILURE,
} from '../actions';

const initialState = {
    loading: false,
    loaded: false,
    data: [],
    error: null,
};

const rejectSetReasonsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_REJECT_SET_REASONS:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_REJECT_SET_REASONS_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
                data: action.payload || [],
                error: null,
            };
        case GET_REJECT_SET_REASONS_FAILURE:
            return {
                ...state,
                loading: false,
                loaded: true,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default rejectSetReasonsReducer;
